<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="买家ID">
          <el-input size="small" style="width:100px" v-model="searchForm.user_id" placeholder="买家ID"></el-input>
        </el-form-item>
        <el-form-item label="买家昵称">
          <el-input size="small" style="width:150px" v-model="searchForm.nickname" placeholder="买家昵称"></el-input>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in delivery" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自提门店">
          <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary"  v-auth="'/customization/operate/export'"  @click="onExport" >导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary"  v-auth="'/customization/operate/export'" @click="editeClick" >自定义导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'申请取消(' + order_count.apply_cancle + ')'" name="apply_cancle"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="c_main">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.fodder" :key="index">
                  <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span v-if="item.fodder_type == 1">酒体 : </span>
                      <span v-if="item.fodder_type == 2">盒型 : </span>
                      <span v-if="item.fodder_type == 3">瓶型 : </span>
                      <span v-if="item.fodder_type == 1"> {{ item.category.name }} </span>
                      <span> {{ item.fodder_name }}</span>
                    </div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.fodder_price }}</div>
                    <div class="gray3">x{{ scope.row.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <p class="orange">订单金额：￥ {{ scope.row.order_price }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.user && scope.row.user.nickName">{{ scope.row.user.nickName }}</div>
              <div class="gray9" v-if="scope.row.user && scope.row.user.user_id">ID：({{ scope.row.user.user_id }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/customization/order/detail'">订单详情</el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10"
                @click="editClick(scope.row,'express')"
                type="text"
                size="small"
                v-auth="'/customization/order/delivery'"
                >
                去发货
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20
                && scope.row.delivery_status.value == 20"
                @click="editClick(scope.row,'track')"
                type="text"
                size="small"
                v-auth="'/customization/express/track'"
              >
                物流轨迹
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 20"
                @click="editClick(scope.row,'extract')"
                type="text"
                size="small"
                v-auth="'/customization/order/operate/extract'"
              >
                去核销
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 20
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.receipt_status.value == 10"
                @click="receiptClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/customization/order/receipt'"
              >
                去收货
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 50"
                @click="distribution(scope.row)"
                type="text"
                size="small"
              >
                去配送
              </el-button>
              <el-button v-if="scope.row.order_status.value == 21" @click="addClick(scope.row)" type="text" size="small" v-auth="'/customization/order/operate/confirmCancel'">去审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <FileUpload v-if="open_add" :open_add="open_add"  @closeDialog="closeDialogFunc($event, 'add')"></FileUpload>

    <Express v-if="open_dialog.express" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'express')"></Express>
    <Track v-if="open_dialog.track" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'track')"></Track>
    <Extract v-if="open_dialog.extract" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'extract')"></Extract>
    <FileExport v-if="open_dialog.fileExport" @closeDialog="closeDialogFunc($event, 'fileExport')"></FileExport>
  </div>
</template>

<script>
import CustomizationApi from '@/api/customization.js';
import qs from 'qs';
import FileUpload from './dialog/FileUpload';
import Extract from './dialog/Extract.vue';
import Express from './dialog/Express.vue';
import Track from './dialog/Track.vue';
import FileExport from './dialog/FileExport.vue';
export default {
  components: {
    /*图片上传*/
    FileUpload: FileUpload,
    /*订单核销*/
    Extract,
    /*快速发货*/
    Express,
    /*物流轨迹*/
    Track,
    /*订单导出*/
    FileExport
  },
  data() {
    return {
      /*是否打开批量发货弹窗*/
      open_add: false,
      /*是否打开订单导出弹窗*/

      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        user_id: "",
        order_no: "",
        nickname: "",
        address: "",
        style_id: '',
        store_id: '',
        create_time: '',
        current_time: ''
      },
      /*配送方式*/
      delivery: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        apply_cancle:0,
      },
      open_dialog: {
        /*快速发货*/
        express: false,
         /*物流轨迹*/
        track: false,
        /*订单核销*/
        extract:false,
        /*订单导出*/
        fileExport:false,
        },
      datascheck: ["订单号","定制栏目信息","订单总额","后台改价","定金","支付方式","下单时间","买家","买家留言","配送方式","自提门店名称","自提联系人","自提联系电话","收货人姓名","联系电话","收货人地址","物流公司","物流单号","付款状态","付款时间","发货状态","发货时间","收货状态","收货时间","订单状态","微信支付交易号"],
      dete: {
        user_id: "",
        order_no: "",
        nickname: ""
        },
      data1: 'all',

      dataModel:{},
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;
    /*获取列表*/
    this.getData();

  },
  methods: {
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      CustomizationApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.delivery = res.data.delivery;
          self.shopList = res.data.shop_list;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/customization/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*打开编辑*/
    editClick(data,type) {
      this.dataModel = data;
      this.open_dialog[type] = true;
    },
    /*订单导出*/
    editeClick() {
      this.open_dialog.fileExport = true;
    },

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let self = this;
      let datascheck = self.datascheck;
      let dete = self.dete;
      let data1 = self.data1;
      let data = [datascheck,dete,data1];
      // console.log(data);
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/customization.Order/export?' + qs.stringify(data);
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        this.getData();

      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        this.getData();
      }
      if (f == 'express') {
        this.open_dialog.express = e.openDialog;
        this.getData();
      }
      if (f == 'track') {
        this.open_dialog.track = e.openDialog;
        this.getData();
      }
      if (f == 'extract') {
        this.open_dialog.extract = e.openDialog;
        this.getData();
      }
      if (f == 'fileExport') {
        this.open_dialog.fileExport = e.openDialog;
        this.getData();
      }
    },
    /*确认收货*/
    receiptClick(row){
      let self = this;
      self
        .$confirm('此操作将确定收货, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          CustomizationApi.orderReceipt(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*开始配送*/
    distribution(row){
      let self = this;
      self
        .$confirm('此操作将开始配送, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          CustomizationApi.distribution(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/customization/order/index.vue